import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const FarmerTargetHarvestReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/farmerwise");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [areaId, setAreaId] = useState(0);
  const [regionData, setRegionData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [fields, setFields] = useState([]);
  const [exportFields, setExportFields] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [identificationData, setIdentificationData] = useState([]);

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(data)
    ? data.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { sendRequest: getprocurementData } = useHttp();

  const fillprocurementData = (employeeId, regionId, identificationNumber) => {
    setData([]);
    let urlfilter = "";

    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (regionId > 0) urlfilter += `&regionId=${regionId}`;
    if (areaId > 0) urlfilter += `&areaId=${areaId}`;
    if (identificationNumber !== "")
      urlfilter += `&identificationNo=${identificationNumber}`;

    const url = `/api/farmerTargetHarvestReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData({ url }, (res) => {
      setData(res.data || []);
      const activeFields = res?.fields
        ?.filter((f) => f.status === 1)
        ?.sort((a, b) => a.sequenceNo - b.sequenceNo);
      setFields(activeFields);
      setExportFields(activeFields?.map((f) => f.dataField));
      setExportHeaders(activeFields?.map((f) => f.headerField));
    });
  };

  useEffect(() => {
    fillprocurementData(0, 0, "");
  }, []);

  const handleExportExcel = () => {
    const filename = "FarmerTargetHarvestReport.xlsx";
    convertToExcel(data, exportFields, filename, exportHeaders);
  };

  const { sendRequest: getEmp } = useHttp();
  const EmployeeDetail = (region) => {
    const url = `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
      "empId"
    )}&orgId=${localStorage.getItem("orgId")}${
      region > 0 ? `&regionId=${region}` : ""
    }`;
    getEmp({ url }, (data) => setEmployeeData(data));
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, []);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => setRegionData(data.data)
    );
  }, []);

  const { sendRequest: getArea } = useHttp();
  useEffect(() => {
    getArea(
      {
        url: `/api/areaDetails/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${employeeId}&regionId=${regionId}`,
      },
      (data) => setAreaData(data)
    );
  }, [employeeId, regionId]);

  const { sendRequest: getIdentificationNumber } = useHttp();
  useEffect(() => {
    getIdentificationNumber(
      {
        url: `/api/farmerIdentificationlist/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => setIdentificationData(data)
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setIdentificationNumber(value);
    setData([]);
  };

  const filteredOptions =
    identificationData &&
    identificationData
      .filter((item) =>
        item.identificationNo
          .toLowerCase()
          .includes(identificationNumber.toLowerCase())
      )
      .map((item) => ({ value: item.identificationNo }));

  return (
    <div className="content-wrapper">
      <div className="row mx-2">
        <div className="col-md-8 mt-3">
          <label className="card-title mx-3">
            Farmer Target Harvest Report
          </label>
        </div>
        <div className="col-md-4 text-right mt-3">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={handleButtonClick}
          >
            <i className="fas fa-times" />
          </button>
        </div>
      </div>

      <br />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* Region */}
            <div className="col-md-3">
              <div className="form-group">
                <label>Region</label>
                <select
                  id="regionId"
                  className="form-control"
                  ref={(el) => (frmRef.current["regionId"] = el)}
                  value={regionId}
                  onChange={(e) => {
                    const regid =
                      e.target.value !== "--Select--" ? e.target.value : 0;
                    setRegionId(regid);
                    EmployeeDetail(regid);
                    setEmployeeId(0);
                    setData([]);
                  }}
                >
                  <option value="">Select</option>
                  {regionData?.map((x) => (
                    <option key={x.regionId} value={x.regionId}>
                      {x.regionName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Procurement Officer */}
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="executive_officer">Procurement Officer</label>
                <select
                  id="emp_id"
                  className="form-control"
                  ref={(el) => (frmRef.current["emp_id"] = el)}
                  value={employeeId}
                  onChange={(e) => {
                    const userid =
                      e.target.value !== "--Select--" ? e.target.value : 0;
                    setEmployeeId(userid);
                    setData([]);
                  }}
                >
                  <option value="0">Select</option>
                  {employeeData?.map((x) => (
                    <option key={x.userId} value={x.userId}>
                      {x.employeeName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Area Name */}
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="area_name">Area Name</label>
                <select
                  id="area_name"
                  className="form-control"
                  ref={(el) => (frmRef.current["area_name"] = el)}
                  value={areaId}
                  onChange={(e) => {
                    setAreaId(e.target.value);
                    setData([]);
                  }}
                >
                  <option value="0">Select</option>
                  {areaData?.map((x) => (
                    <option key={x.areaId} value={x.areaId}>
                      {x.areaName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Identification Number */}
            <div className="col-md-3">
              <label htmlFor="identification_number">
                Identification Number
              </label>
              <AutoComplete
                className="form-control"
                style={{ height: "30px" }}
                value={identificationNumber}
                options={filteredOptions}
                placeholder="Identification Number"
                onChange={handleSearch}
              />
            </div>

            {/* Submit Button */}
            <div className="col-md-3 text-right">
              <div className="form-group">
                <label>&nbsp;</label>
                <button
                  className="form-control btn btn-sm btn-primary"
                  onClick={() =>
                    fillprocurementData(
                      employeeId,
                      regionId,
                      identificationNumber
                    )
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        <h5>Please select the parameters to get the desired result</h5>
        <hr />
      </section>

      <section className="content">
        <div className="container-fluid">
          {data.length > 0 && (
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
          )}

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                {data.length > 0 ? (
                  <>
                    <div className="card-body" style={{ padding: "0.4rem" }}>
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <thead>
                          <tr className="table-header">
                            {fields?.map((field, index) => (
                              <th key={index}>{field.headerField}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems?.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              {fields?.map((field, j) => {
                                const value = itm[field.dataField];
                                if (field.dataField === "urlProfile") {
                                  return (
                                    <td key={j}>
                                      <img
                                        src={`${process.env.REACT_APP_FILE_URL}${value}`}
                                        className="user-image img-circle"
                                        width="60"
                                        height="60"
                                        alt="Profile"
                                      />
                                    </td>
                                  );
                                }

                                if (field.dataField === "urlAttachment") {
                                  return (
                                    <td key={j}>
                                      <a
                                        href={`${process.env.REACT_APP_FILE_URL}${value}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Id Proof
                                      </a>
                                    </td>
                                  );
                                }

                                if (field.dataField === "signatureAttachment") {
                                  return (
                                    <td key={j}>
                                      <img
                                        src={`${process.env.REACT_APP_FILE_URL}${value}`}
                                        className="user-image img-circle"
                                        alt="Signature"
                                        height="60"
                                        width="60"
                                      />
                                    </td>
                                  );
                                }

                                return <td key={j}>{value}</td>;
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </>
                ) : (
                  <p className="text-center">No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FarmerTargetHarvestReport;
